<!-- {{ widgetData | json }} -->
<div class="map" [id]="getWidgetId">
    <google-map
        *ngIf="credentialsFacade.isMapsApiLoaded$ | async"
        [options]="mapOptions"
        [height]="null"
        [width]="null"
        [center]="widgetData.tempCenter || widgetData.center"
        [zoom]="widgetData.zoom"
        (zoomChanged)="changeZoom()"
        (mapInitialized)="mapInitialized($event)"
        (mapDragend)="mapMoved()"
    >
        <div [class.blur]="blurMap" class="blurContainer"></div>
        <map-marker
            #markerRef="mapMarker"
            *ngFor="let marker of widgetData.addresses"
            [position]="marker.position"
            [title]="marker.title"
            (mapClick)="openInfo(window, markerRef)"
        >
            <map-info-window #window="mapInfoWindow">
                <h3>{{ marker.title }}</h3>
                <p>
                    {{ marker.description }} <br *ngIf="marker.description" />

                    {{ marker.address }}
                </p>
            </map-info-window>
        </map-marker>
    </google-map>
</div>
